import Backend from 'backend';
import {inject} from 'aurelia-framework';
import {FeatureCustomizationProvider} from "../util/feature-customization-provider";

@inject(Backend, FeatureCustomizationProvider)
export class CustomerPortalOrderDetailsScreen {
  backend;
  order;
  featureCustomizationProvider;
  backUrl;

  constructor(backend, featureCustomizationProvider) {
    this.backend = backend;
    this.featureCustomizationProvider = featureCustomizationProvider;
  }

  activate(params) {
    this.backUrl = params.backUrl;
    return this.backend.CustomerPortalOrderDetailsQueryHandler_handle({orderId: params.orderId})
      .then(result => this.order = result);
  }
}
